import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IMajorSuggestionResponse } from '../../major_explorer_interface';
import { MajorProgram } from './../builders/major_programs_builder';

export class ProgramsQuestionFunction {
  programs: IMajorSuggestionResponse;
  favoritePrograms: MajorProgram[];

  constructor(private loadProgramsCommand: ICommand, private loadFavoriteProgramsCommand: ICommand) {}

  loadMajorExplorer() {
    return this.loadProgramsCommand().then((programsResponse: IMajorSuggestionResponse) => {
      this.programs = programsResponse;
      return programsResponse;
    });
  }

  loadFavorites() {
    return this.loadFavoriteProgramsCommand().then((favoriteResponse: { program: MajorProgram[] }) => {
      this.favoritePrograms = _4.toArray(favoriteResponse.program);
      return favoriteResponse;
    });
  }

  coreInitialize(): boolean {
    return true;
  }
}

angular.module('major-explorer-data').service('programsQuestionFn', ProgramsQuestionFunction);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/functions/programs_fn.ts